import React from "react";

export default function LoadingForm() {
  return <div>Loading Form...</div>;
}
